import { combineToList, PageService, PageBaseClass, SortedFilteredList, StoreLoader, IAction, combineEither, } from '@aston/foundation';
import { LoaderSpinnerComponent, ListPagingComponent } from '@aston/foundation/components';
import { TranslateDirective } from '@ngx-translate/core';
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { Observable, concat } from 'rxjs';
import { Store } from '@ngrx/store';
import { ListActionHandler } from 'apps/console/src/app/shared-module/classes/list-handler.class';

import { FederationUsersListTableComponent } from '../../components/federation-users-list-table/federation-users-list-table.component';
import { FederationDetailStoreActions, FederationDetailStoreSelectors } from '../../../root-store/federation-detail-store';
import { AppStoreSelectors } from '../../../root-store/app-store';
import { FederationUsersListSortProp } from '../../enums';
import { IFederationUser } from '../../models';

@Component({
	selector: 'federation-detail-users-page',
	templateUrl: './federation-detail-users-page.component.html',
	imports: [TranslateDirective, LoaderSpinnerComponent, FederationUsersListTableComponent, ListPagingComponent, AsyncPipe]
})
export class FederationDetailUsersPageComponent extends PageBaseClass implements OnInit {
	protected pageService = inject(PageService);;
	private route = inject(ActivatedRoute);
	private store = inject(Store);

	federationId: number;
	listHandler: ListActionHandler;

	list$: Observable<SortedFilteredList<IFederationUser, FederationUsersListSortProp>> = combineToList(
		this.store.select(FederationDetailStoreSelectors.selectUsersList),
		this.store.select(FederationDetailStoreSelectors.selectUsersListPaging)
	);

	loader = new StoreLoader(
		combineEither(
			this.store.select(FederationDetailStoreSelectors.selectUsersIsLoading),
			this.store.select(FederationDetailStoreSelectors.selectUserStatusIsLoading)),
		concat(
			this.store.select(FederationDetailStoreSelectors.selectUserStatusError),
			this.store.select(FederationDetailStoreSelectors.selectUsersError)));

	currentUser$ = this.store.select(AppStoreSelectors.selectUser);
	currentFederation$ = this.store.select(FederationDetailStoreSelectors.selectFederation);

	ngOnInit() {
		super.ngOnInit();
		this.federationId = +this.route.parent.snapshot.params.id;

		this.listHandler = new ListActionHandler().withPagingDispatcher(this.dispatchPagingAction.bind(this));
		this.loadFederation();

		this.currentFederation$.subscribe(_ => {
			this.store.dispatch(FederationDetailStoreActions.LoadUsersListRequest());
		});

	}

	loadFederation() {
		this.store.dispatch(FederationDetailStoreActions.LoadFederationRequest(this.federationId));
	}

	dispatchPagingAction(props) {
		this.store.dispatch(FederationDetailStoreActions.UpdateUsersListSettings(props));
	}

	updateRegistrationRequest(action: IAction) {
		this.store.dispatch(FederationDetailStoreActions.ResentUserInvitationRequest(action.value));
	}

	createUser() {
		this.store.dispatch(FederationDetailStoreActions.OpenFederationUserForm());
	}

	updateStatus(action: IAction) {
		this.store.dispatch(FederationDetailStoreActions.UpdateTransientUserStatusRequest({
			userId: action.value.userId,
			userStatus: action.value.userStatus,
		}));
	}
}
